module.exports = {
      id: "sagitarius-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#sagitarius",
      toString: function () {
        return this.url;
      }
    }